import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import LegalTextWrapper from 'components/LegalText';
import { useDecision } from 'lib/helpers/optimizely';
import {
  ABTestKeys,
  BLACK_FRIDAY_FLAG,
} from 'lib/helpers/optimizely/flagConfigs';
import {
  legalTextGoogleFooter50K,
  legalTextSeaShort30K,
  legalText20K,
} from 'lib/constants/legalTexts';

// Important for the Legal Page Footer:
// Size may not be smaller than 14 on desktop
// due to legal reasons
// We have a cease and desist on that
// If in doubt, talk to legal dept.
export const TrustText = styled(Typography)(({ theme }) => ({
  fontSize: '8px',
  color: theme.palette.text.tertiary,
  wordBreak: 'break-word',
  lineHeight: '13px',
  margin: `${theme.spacing(1)} 0`,
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
    color: theme.palette.text.primary,
    lineHeight: '20px',
  },
  '& a': {
    fontWeight: 500,
    color: theme.palette.primary.main,
    '&:hover': {
      opacity: 0.75,
    },
  },
}));

export const SeaStageTrustText = styled(Typography)(({ theme }) => ({
  fontSize: '12px',

  color: theme.palette.text.primary,
  wordBreak: 'break-word',
  lineHeight: '20px',
  margin: `${theme.spacing(1)} ${theme.spacing(1)}`,

  [theme.breakpoints.up('md')]: {
    margin: `${theme.spacing(1)} 0`,
  },

  '& a': {
    fontWeight: 500,
    color: theme.palette.text.primary,
    textDecorationColor: theme.palette.text.primary,
    '&:hover': {
      opacity: 0.75,
    },
  },
}));

export const TvTrustText = styled(Typography)(({ theme }) => ({
  fontSize: '8px',
  color: theme.palette.text.secondary,
  wordBreak: 'break-word',
  margin: `${theme.spacing(1)} 0`,
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
}));

export const LegalTextShort = () => {
  return (
    <>
      <TrustText>
        &#42; Weitere Informationen sowie die Garantie-Bedingungen{' '}
        <a href="https://www.smava.de/kredit/guenstiger">finden Sie hier</a>
      </TrustText>
    </>
  );
};

export const LegalTextSEAShort = () => {
  return (
    <SeaStageTrustText>
      * <Link href="https://www.smava.de/kredit/guenstiger/">Mehr Infos</Link>
      <br />
      ** <Link href="https://www.smava.de/kredit/info/">Mehr Infos</Link>
      <br />
      *** {legalTextSeaShort30K}
    </SeaStageTrustText>
  );
};

export const LegalTextGoogleFooter = ({
  showRadioText,
}: {
  showRadioText?: boolean;
}) => {
  const [decision] = useDecision(ABTestKeys.CAT3106_Black_friday_banner);
  const showBlackFridayBadge = decision.variationKey === BLACK_FRIDAY_FLAG;

  return (
    <LegalTextWrapper isSEAPage>
      <br />
      {legalTextGoogleFooter50K}
      <br />
      <br />
      {showBlackFridayBadge ? (
        <>
          * Kreditvergleich mit aufgestockter Günstiger-Geht-Nicht-Garantie.
          Weitere Informationen sowie die Garantie-Bedingungen{' '}
          <a href="https://www.smava.de/kredit/guenstiger">finden Sie hier</a>
        </>
      ) : (
        <>
          * <a href="https://www.smava.de/kredit/guenstiger/">Mehr Infos</a>
        </>
      )}
      <br />
      ** <a href="https://www.smava.de/kredit/info/">Mehr Infos</a>
      <br />
      {showRadioText && (
        <>
          *** ARD: Morgenmagazin (02.02.2023); ZDF: Morgenmagazin (02.02.2023);
          NTV: Telebörse (25.10.2023); RTL: Punkt 12 (04.03.2024).
        </>
      )}
    </LegalTextWrapper>
  );
};

export const LegalTextGoogleForEmailPartnerFooter = () => {
  return (
    <LegalTextWrapper isSEAPage>
      <br />
      {legalText20K} <br />
      <br /> *{' '}
      <Link href="https://www.smava.de/kredit/guenstiger/">Mehr Infos</Link>
      <br />
      ** <Link href="https://www.smava.de/kredit/info/">Mehr Infos</Link>
      <br />
    </LegalTextWrapper>
  );
};

export const LegalTextGoogleForDisplayFooter = () => {
  return (
    <LegalTextWrapper isSEAPage={false}>
      <br />
      {legalText20K} <br />
      <br /> *{' '}
      <Link href="https://www.smava.de/kredit/guenstiger/">Mehr Infos</Link>
      <br />
      ** <Link href="https://www.smava.de/kredit/info/">Mehr Infos</Link>
      <br />
    </LegalTextWrapper>
  );
};

export const LegalTextBestPriceGuarantee = () => {
  return (
    <SeaStageTrustText>
      * Nur mit{' '}
      <Link href="https://www.smava.de/kredit/guenstiger/">
        Günstiger-Geht-Nicht-Garantie
      </Link>
    </SeaStageTrustText>
  );
};
